import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
    getCallStatusColor,
    getCallOutcomeColor,
    getButtonColor
} from "../utils/callStatusColor.util";

/**
 * Reusable Call Details Button Component with Status Display and Tooltip
 * Used across Incoming Calls, Contact Us, Quote, and Cold Leads modules
 */
const CallDetailsButtonWithStatus = ({
    lead,
    onCallDetailsPageClick,
    getCallStatus,
}) => {
    const [callStatus, setCallStatus] = useState(null);

    useEffect(() => {
        if (lead?._id) {
            getCallStatus(lead).then((status) => {
                setCallStatus(status);
            });
        }
    }, [lead?._id, getCallStatus, lead]);

    const displayStatus =
        callStatus?.status === "Call Concluded" ||
            callStatus?.status === "Not Interested" ||
            callStatus?.status === "Not Concluded"
            ? "Success"
            : callStatus?.status || "Call";

    const { backgroundColor, color, iconColor } = getButtonColor(
        displayStatus,
        callStatus?.status,
        callStatus?.outcome
    );

    const tooltipStatusColor = getCallStatusColor(displayStatus, callStatus?.status);
    const tooltipOutcomeColor = getCallOutcomeColor(callStatus?.outcome);

    const tooltip = (
        <Tooltip id={`call-status-${lead?._id}`}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    minWidth: "220px",
                    textAlign: "left",
                }}
            >
                <div style={{ whiteSpace: "nowrap" }}>
                    <strong>Date:</strong> {callStatus?.date || "-"}
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                    <strong>Time:</strong> {callStatus?.time || "-"}
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                    <strong>Call Status:</strong>{" "}
                    <span style={{ color: tooltipStatusColor, fontWeight: 600 }}>
                        {displayStatus}
                    </span>
                </div>
                <div style={{ whiteSpace: "nowrap" }}>
                    <strong>Call Outcome:</strong>{" "}
                    <span style={{ color: tooltipOutcomeColor, fontWeight: 600 }}>
                        {callStatus?.outcome || "-"}
                    </span>
                </div>
            </div>
        </Tooltip>
    );

    return (
        <OverlayTrigger placement="top" overlay={tooltip}>
            <button
                className="inline-action-btn inline-status-btn"
                onClick={() => onCallDetailsPageClick(lead)}
                title="Call Details"
                style={{
                    backgroundColor: backgroundColor || undefined,
                    color: color || undefined,
                    borderColor: backgroundColor || undefined,
                }}
            >
                <svg viewBox="0 0 640 640" style={{ width: "16px", height: "16px" }}>
                    <path
                        d="M320 128C241 128 175.3 185.3 162.3 260.7C171.6 257.7 181.6 256 192 256L208 256C234.5 256 256 277.5 256 304L256 400C256 426.5 234.5 448 208 448L192 448C139 448 96 405 96 352L96 288C96 164.3 196.3 64 320 64C443.7 64 544 164.3 544 288L544 456.1C544 522.4 490.2 576.1 423.9 576.1L336 576L304 576C277.5 576 256 554.5 256 528C256 501.5 277.5 480 304 480L336 480C362.5 480 384 501.5 384 528L384 528L424 528C463.8 528 496 495.8 496 456L496 435.1C481.9 443.3 465.5 447.9 448 447.9L432 447.9C405.5 447.9 384 426.4 384 399.9L384 303.9C384 277.4 405.5 255.9 432 255.9L448 255.9C458.4 255.9 468.3 257.5 477.7 260.6C464.7 185.3 399.1 127.9 320 127.9z"
                        fill={iconColor}
                    />
                </svg>
            </button>
        </OverlayTrigger>
    );
};

export default CallDetailsButtonWithStatus;
